import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { RpPaymentLinksComponent } from './payment-links/payment-links.component';

const routes: Routes = [

  { path: 'paymentlinks', component: RpPaymentLinksComponent },

];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PaymentLinksRoutingModule { }
